import { MinzeElement } from 'minze'

export interface LvcCalendarAltIcon {}

export class LvcCalendarAltIcon extends MinzeElement {
  html = () => `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.79297 3.6308L21.4277 3.91823M21.6568 3.83233C22.0539 5.24527 22.4012 6.87743 22.4127 8.34507C22.4127 8.38094 22.4053 8.41605 22.3914 8.44836C22.389 8.51413 22.3618 8.57671 22.3151 8.62341C22.2662 8.67232 22.1999 8.6998 22.1307 8.6998L1.93235 8.53288C1.86317 8.53288 1.79683 8.50539 1.74791 8.45648C1.71148 8.42004 1.68693 8.37394 1.67678 8.32419C1.66676 8.29658 1.66117 8.26531 1.66117 8.2304C1.7029 6.82194 1.6655 5.19941 1.58203 3.79095M17.0238 9.53775C17.2259 7.92563 17.1601 4.38558 17.0238 2.48404M6.30269 2.30083L6.52026 9.48049M21.5862 22.0024L2.27132 21.5338C2.24022 21.5465 2.20665 21.5533 2.17239 21.5533C2.10321 21.5533 2.03687 21.5258 1.98796 21.4769C1.93904 21.428 1.91156 21.3616 1.91156 21.2925C2.05067 17.9191 2.05317 14.265 1.91406 10.8847M21.4109 21.7648C21.4141 18.1602 21.5397 14.3704 21.8178 10.7864C21.8178 10.5741 21.6314 10.4967 21.4811 10.5468C15.0867 10.6648 8.43046 10.7042 2.04297 10.6347" stroke="#1E007D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `

  css = () => `
    
  `
}
